
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCancelPolicy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCancelPolicy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"result"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"policyName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"policyContent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"priorDays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"accommodationPriorCheckIn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"accommodationBeforeCheckIn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"accommodationDuringCheckIn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"guestFeePriorCheckIn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"guestFeeBeforeCheckIn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"guestFeeDuringCheckIn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hostFeePriorCheckIn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hostFeeBeforeCheckIn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hostFeeDuringCheckIn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nonRefundableNightsPriorCheckIn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nonRefundableNightsBeforeCheckIn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nonRefundableNightsDuringCheckIn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subContent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"content1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"content2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"content3"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":633}};
    doc.loc.source = {"body":"query getCancelPolicy ($id: Int!) {\n  getCancelPolicy (id: $id) {\n    status\n    errorMessage\n    result{\n      id\n      policyName\n      policyContent\n      priorDays\n      accommodationPriorCheckIn\n      accommodationBeforeCheckIn\n      accommodationDuringCheckIn\n      guestFeePriorCheckIn\n      guestFeeBeforeCheckIn\n      guestFeeDuringCheckIn\n      hostFeePriorCheckIn\n      hostFeeBeforeCheckIn\n      hostFeeDuringCheckIn\n      nonRefundableNightsPriorCheckIn\n      nonRefundableNightsBeforeCheckIn\n      nonRefundableNightsDuringCheckIn\n      subTitle\n      subContent\n      content1\n      content2\n      content3\n    }\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["getCancelPolicy"] = oneQuery(doc, "getCancelPolicy");
        
